<template>
  <div class="mit-admin-page mit-page">

    <v-container fluid>
        <v-row>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card" style="width:100%">
              <v-card-title>Admin - Acount Management</v-card-title>
              <v-card-subtitle class="caption">CSAIL Account Management</v-card-subtitle>
              <v-divider></v-divider>

              <v-card-text>
                <v-container>
                  <h3 class="pt-5">
                    Change Password OIDC/Kerberos
                  </h3>
                  <p>Change your or another user's OIDC/Kerberos password. You must know the existing password. </p>
                  <v-btn color="primary" to="/password/change">Change</v-btn>
                </v-container>
                <div v-if="showResetFeature" class="container">
                  <h3 class="pt-5">
                    Forgot Password OIDC/Kerberos
                  </h3>
                  <p>Click here to email a reset password link to a user or generate a reset password link. This link is only usable for 1 attempt and expires after a period of time. </p>
                  <v-btn color="primary" to="/admin/reset/link">Create Reset Link</v-btn>
                </div>

                <div v-if="showResetFeature" class="container">
                  <h3 class="pt-5">
                    Monitor
                  </h3>
                  <p>Click here to see user activity or reset or changing passwords. </p>
                  <v-btn color="primary" to="/admin/activity">Activity</v-btn>
                </div>
                <v-divider class="mt-5"/>
                <div v-if="featureToggleWifiPass" class="container">
                  <h3 class="pt-5">
                    Application settings
                  </h3>
                  <p>Settings for meraki wifi and in the future other configuration things</p>
                  <v-btn color="primary" to="/admin/settings">Settings</v-btn>
                </div>
              </v-card-text>

            </v-card>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitConfigService from '../../../base/services/BaseMitConfigService.js';

  export default {
    name: 'MitAdminPage',
    components: {
    },
    data: function() {
      return {
        showResetFeature:true,
        featureToggleWifiPass:false
      }
    },
    created() {
      this.featureToggleWifiPass = BaseMitConfigService.getFeatureEnabled('feature-toggle-wifi-pass');
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
  .container {
    margin-bottom: 20px;
    background-color: #ececec;
    border: 1px solid #ccc;
    border-radius: 2px;
    max-width: 100%;
  }
</style>
